/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { ArbitrageStatus } from "../ArbitrageStatus";

export class ArbitrageStatus__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<ArbitrageStatus> {
    return super.deploy(overrides || {}) as Promise<ArbitrageStatus>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ArbitrageStatus {
    return super.attach(address) as ArbitrageStatus;
  }
  connect(signer: Signer): ArbitrageStatus__factory {
    return super.connect(signer) as ArbitrageStatus__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ArbitrageStatus {
    return new Contract(address, _abi, signerOrProvider) as ArbitrageStatus;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "LevelCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "tx1",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "tx2",
        type: "bytes32",
      },
    ],
    name: "TransactionsSet",
    type: "event",
  },
  {
    inputs: [],
    name: "clearPendingUsers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getPendingUsers",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "hasPlayed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "hasSucceeded",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initializeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bool",
        name: "completed",
        type: "bool",
      },
    ],
    name: "setCompleted",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tx1",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "tx2",
        type: "bytes32",
      },
    ],
    name: "setTransactions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "users",
    outputs: [
      {
        internalType: "bool",
        name: "waitingForCheck",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "completed",
        type: "bool",
      },
      {
        internalType: "bytes32",
        name: "tx1",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "tx2",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
